import React, { useState, createContext, useCallback } from 'react'
import PropTypes from 'prop-types'

export const OverlayContext = createContext({})

export const OverlayContextProvider = ({ children }) => {
  const [overlayIdHistory, setOverlayIdHistory] = useState([])

  const activeOverlayId = overlayIdHistory[overlayIdHistory.length - 1]

  const handleOverlayBack = useCallback(() => {
    const existingIds = [...overlayIdHistory]
    existingIds.pop()
    setOverlayIdHistory(existingIds)
  }, [overlayIdHistory])

  const handleAddOverlay = useCallback(
    (id) => {
      const existingIds = [...overlayIdHistory]
      existingIds.push(id)
      setOverlayIdHistory(existingIds)
    },
    [overlayIdHistory]
  )

  const value = {
    setOverlayIdHistory,
    activeOverlayId,
    handleAddOverlay,
    handleOverlayBack,
  }

  return (
    <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>
  )
}

OverlayContextProvider.propTypes = {
  children: PropTypes.any,
}
